<template>
  <router-link
    activeClass="inspection-card--active"
    class="inspection-card"
    :to="{ name: routePathName, params: { jobId: job.id, scope: jobScope } }"
  >
    <div
      ref="card"
      class="inspection-card__body"
    >
      <div class="inspection-card__header">
        <p class="typo-ignore typo-small-title inspection-card__title">
          <span class="inspection-card__job-title">{{ $t(`shafts.element_types.${baseElementType}.${elementType}`) }}</span>
          <span class="inspection-card__job-id">#{{ job.id && shortId }}</span>
        </p>
        <p class="inspection-card__work-orders typo-ignore typo-smallish">
          {{
            pluralize(
              job.work_orders.length,
              $t("activerecord.models.shafts/work_order.one"),
              $t("activerecord.models.shafts/work_order.other")
            )
          }}
        </p>
      </div>
      <div class="inspection-card__info">
        <p class="typo-ignore typo-smallish inspection-card__planner">
          {{ job.planner ? job.planner.full_name : $t('shafts.jobs.unassigned') }}
        </p>
        <p
          v-if="job.maintenance_action"
          class="typo-ignore typo-smallish inspection-card__maintenance-action"
        >
          {{ $t(`shafts.maintenance_actions.${job.maintenance_action}`) }}
        </p>
      </div>
      <!-- Work order dots, modified in colour using rating level -->
      <div
        v-if="job.work_orders"
        class="inspection-card__issue-summary"
      >
        <div
          v-for="(rating, index) in workOrderDots"
          :key="index"
          :class="`inspection-card__issue inspection-card__issue--${rating}`"
        />
      </div>
    </div>
  </router-link>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';

// Utils
import pluralize from '@/functions/pluralize';
import { renderShortId } from '@/functions/utils.js';
import { isInViewport } from '@/functions/utils';

const props = defineProps({
  job: { type: Object, required: true },
  pathName: { type: String, required: false, default: null },
});

const route = useRoute();

const card = ref(null);

watchEffect(() => {
  if (card.value && route.name === 'job' && route.params.jobId === props.job.id) {
    if (!isInViewport(card.value)) {
      card.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
});

const baseElementType = computed(() => props.job.element_type.split('/')[0]);
const elementType = computed(() => props.job.element_type.split('/')[1]);

const jobScope = computed(() => {
  return props.job.status === 'completed' ? 'completed_jobs' : 'jobs';
});

const shortId = computed(() => renderShortId(props.job.id));

const workOrderDots = computed(() => {
  return props.job.work_orders
    .map((i) => i.activity.overall_condition_rating)
    .sort((a, b) => b - a);
});

const routePathName = computed(() => {
  return props.pathName || 'shaftJob';
});
</script>
